export interface MockJob {
  id: string
  title: string
  department: string
  location: string
  type: "Full-time" | "Part-time" | "Contract" | "Internship"
  status: "active" | "paused" | "closed" | "draft"
  salary: string
  applicants: number
  interviews: number
  posted: string
  description: string
  requirements: string[]
  hiringManagers: { name: string; role: string; email: string; avatar?: string }[]
  company: string
  remote: boolean
  experience: string
  skills: string[]
}

export const mockJobs: MockJob[] = [
  {
    id: "1",
    title: "Senior Software Engineer",
    department: "Engineering",
    location: "San Francisco, CA",
    type: "Full-time",
    status: "active",
    salary: "$150k - $200k",
    applicants: 12,
    interviews: 3,
    posted: "2 days ago",
    description: "We're looking for a senior software engineer to join our growing team.",
    requirements: ["5+ years experience", "React", "Node.js", "TypeScript"],
    hiringManagers: [
      { name: "Sarah Johnson", role: "Engineering Manager", email: "sarah.johnson@techcorp.com" },
      { name: "Mike Chen", role: "Senior Engineering Manager", email: "mike.chen@techcorp.com" },
    ],
    company: "TechCorp",
    remote: false,
    experience: "Senior",
    skills: ["React", "Node.js", "TypeScript", "AWS"],
  },
  {
    id: "2",
    title: "Product Manager",
    department: "Product",
    location: "Remote",
    type: "Full-time",
    status: "active",
    salary: "$130k - $170k",
    applicants: 8,
    interviews: 2,
    posted: "1 week ago",
    description: "Lead product strategy and execution for our core platform.",
    requirements: ["3+ years PM experience", "B2B SaaS", "Analytics"],
    hiringManagers: [
      { name: "Lisa Wang", role: "VP of Product", email: "lisa.wang@productco.com" },
      { name: "David Brown", role: "Product Director", email: "david.brown@productco.com" },
    ],
    company: "ProductCo",
    remote: true,
    experience: "Mid-level",
    skills: ["Product Strategy", "Analytics", "Roadmapping", "Stakeholder Management"],
  },
  {
    id: "3",
    title: "Frontend Developer",
    department: "Engineering",
    location: "New York, NY",
    type: "Full-time",
    status: "paused",
    salary: "$120k - $160k",
    applicants: 6,
    interviews: 1,
    posted: "3 days ago",
    description: "Build beautiful, responsive user interfaces for our web applications.",
    requirements: ["3+ years frontend", "React", "CSS", "JavaScript"],
    hiringManagers: [
      { name: "Alex Rodriguez", role: "Frontend Lead", email: "alex.rodriguez@designtech.com" },
      { name: "Emma Wilson", role: "Engineering Manager", email: "emma.wilson@designtech.com" },
    ],
    company: "DesignTech",
    remote: false,
    experience: "Mid-level",
    skills: ["React", "CSS", "JavaScript", "Figma"],
  },
  {
    id: "4",
    title: "DevOps Engineer",
    department: "Engineering",
    location: "Austin, TX",
    type: "Full-time",
    status: "active",
    salary: "$140k - $180k",
    applicants: 15,
    interviews: 5,
    posted: "5 days ago",
    description: "Manage infrastructure and deployment pipelines for our cloud-native applications.",
    requirements: ["4+ years DevOps", "AWS", "Kubernetes", "CI/CD"],
    hiringManagers: [
      { name: "John Smith", role: "DevOps Manager", email: "john.smith@cloudtech.com" },
      { name: "Maria Garcia", role: "Infrastructure Lead", email: "maria.garcia@cloudtech.com" },
    ],
    company: "CloudTech",
    remote: true,
    experience: "Senior",
    skills: ["AWS", "Kubernetes", "Docker", "Terraform"],
  },
  {
    id: "5",
    title: "Data Scientist",
    department: "Data",
    location: "Seattle, WA",
    type: "Full-time",
    status: "active",
    salary: "$160k - $220k",
    applicants: 20,
    interviews: 7,
    posted: "1 week ago",
    description: "Apply machine learning to solve complex business problems.",
    requirements: ["PhD or Masters", "Python", "ML/AI", "Statistics"],
    hiringManagers: [
      { name: "Dr. Jennifer Lee", role: "Data Science Director", email: "jennifer.lee@datacorp.com" },
      { name: "Robert Kim", role: "ML Engineering Manager", email: "robert.kim@datacorp.com" },
    ],
    company: "DataCorp",
    remote: false,
    experience: "Senior",
    skills: ["Python", "Machine Learning", "Statistics", "SQL"],
  },
  {
    id: "6",
    title: "UX Designer",
    department: "Design",
    location: "Los Angeles, CA",
    type: "Full-time",
    status: "active",
    salary: "$110k - $150k",
    applicants: 9,
    interviews: 2,
    posted: "4 days ago",
    description: "Design intuitive user experiences for our mobile and web applications.",
    requirements: ["3+ years UX", "Figma", "User Research", "Prototyping"],
    hiringManagers: [
      { name: "Sophie Chen", role: "Design Manager", email: "sophie.chen@designstudio.com" },
      { name: "Mark Thompson", role: "UX Director", email: "mark.thompson@designstudio.com" },
    ],
    company: "DesignStudio",
    remote: true,
    experience: "Mid-level",
    skills: ["Figma", "User Research", "Prototyping", "Design Systems"],
  },
  {
    id: "7",
    title: "Backend Engineer",
    department: "Engineering",
    location: "Boston, MA",
    type: "Full-time",
    status: "closed",
    salary: "$130k - $170k",
    applicants: 25,
    interviews: 8,
    posted: "2 weeks ago",
    description: "Build scalable backend services and APIs.",
    requirements: ["4+ years backend", "Python/Java", "Databases", "APIs"],
    hiringManagers: [
      { name: "Tom Wilson", role: "Backend Lead", email: "tom.wilson@backendtech.com" },
      { name: "Anna Rodriguez", role: "Engineering Manager", email: "anna.rodriguez@backendtech.com" },
    ],
    company: "BackendTech",
    remote: false,
    experience: "Senior",
    skills: ["Python", "PostgreSQL", "Redis", "Microservices"],
  },
  {
    id: "8",
    title: "Marketing Manager",
    department: "Marketing",
    location: "Chicago, IL",
    type: "Full-time",
    status: "draft",
    salary: "$90k - $120k",
    applicants: 0,
    interviews: 0,
    posted: "Draft",
    description: "Lead marketing campaigns and growth initiatives.",
    requirements: ["3+ years marketing", "Digital marketing", "Analytics", "B2B"],
    hiringManagers: [
      { name: "Jessica Park", role: "Marketing Director", email: "jessica.park@marketingpro.com" },
      { name: "Michael Davis", role: "Growth Manager", email: "michael.davis@marketingpro.com" },
    ],
    company: "MarketingPro",
    remote: true,
    experience: "Mid-level",
    skills: ["Digital Marketing", "Analytics", "Content Strategy", "SEO"],
  },
]

export function getJobById(id: string): MockJob | undefined {
  return mockJobs.find((job) => job.id === id)
}

export function getActiveJobs(): MockJob[] {
  return mockJobs.filter((job) => job.status === "active")
}

export function getRecentJobs(limit = 5): MockJob[] {
  return mockJobs
    .filter((job) => job.status === "active")
    .sort((a, b) => new Date(b.posted).getTime() - new Date(a.posted).getTime())
    .slice(0, limit)
}

const hiringManagersData: { [key: string]: { name: string; role: string; email: string; avatar?: string } } = {
  "Sarah Johnson": { name: "Sarah Johnson", role: "Engineering Manager", email: "sarah.johnson@techcorp.com" },
  "Mike Chen": { name: "Mike Chen", role: "Senior Engineering Manager", email: "mike.chen@techcorp.com" },
  "Lisa Wang": { name: "Lisa Wang", role: "VP of Product", email: "lisa.wang@productco.com" },
  "David Brown": { name: "David Brown", role: "Product Director", email: "david.brown@productco.com" },
  "Alex Rodriguez": { name: "Alex Rodriguez", role: "Frontend Lead", email: "alex.rodriguez@designtech.com" },
  "Emma Wilson": { name: "Emma Wilson", role: "Engineering Manager", email: "emma.wilson@designtech.com" },
  "John Smith": { name: "John Smith", role: "DevOps Manager", email: "john.smith@cloudtech.com" },
  "Maria Garcia": { name: "Maria Garcia", role: "Infrastructure Lead", email: "maria.garcia@cloudtech.com" },
  "Dr. Jennifer Lee": { name: "Dr. Jennifer Lee", role: "Data Science Director", email: "jennifer.lee@datacorp.com" },
  "Robert Kim": { name: "Robert Kim", role: "ML Engineering Manager", email: "robert.kim@datacorp.com" },
  "Sophie Chen": { name: "Sophie Chen", role: "Design Manager", email: "sophie.chen@designstudio.com" },
  "Mark Thompson": { name: "Mark Thompson", role: "UX Director", email: "mark.thompson@designstudio.com" },
  "Tom Wilson": { name: "Tom Wilson", role: "Backend Lead", email: "tom.wilson@backendtech.com" },
  "Anna Rodriguez": { name: "Anna Rodriguez", role: "Engineering Manager", email: "anna.rodriguez@backendtech.com" },
  "Jessica Park": { name: "Jessica Park", role: "Marketing Director", email: "jessica.park@marketingpro.com" },
  "Michael Davis": { name: "Michael Davis", role: "Growth Manager", email: "michael.davis@marketingpro.com" },
}

export function getHiringManagersByNames(names: string[]) {
  return names.map((name) => hiringManagersData[name]).filter(Boolean)
}
